import FcaQuestionnaireForm from '@/features/onboarding/fca-questionnaire/components/form';
import FcaQuestionnaireLayout from '@/features/onboarding/fca-questionnaire/layout';

const FcaQuestionnairePage = () => {
  return (
    <FcaQuestionnaireLayout>
      <FcaQuestionnaireForm />
    </FcaQuestionnaireLayout>
  );
};
FcaQuestionnairePage.displayName = 'FcaQuestionnairePage';

export default FcaQuestionnairePage;
